module.exports = __webpack_public_path__ + "images/emoji/bookmark_tabs.a96ab9d00c07573e75ce.png";